interface SkeletonProps {
	className?: string
}

const Skeleton = ({ className }: SkeletonProps) => (
	<div aria-hidden className={`skeleton ${className ?? ''}`} />
)

export default Skeleton
